<template>
  <div class="row">
    <div class="col--12">
      <!-- A question is considered answered when it loses focus -->
    </div>
    <div v-if="valueType === 0" class="col--12">
      <input
        v-enter-to-tab
        :key="textInputKey"
        type="text"
        class="form-control form-control--text open-answer-option-input EnterToTab"
        :class="{ 'input-invalid': isInvalid }"
        :required="isRequired"
        :value="value"
        :readonly="viewMode"
        :disabled="viewMode"
        @blur="answered"
        @change="textValueChange"
      />
      <div v-if="isInvalid" class="errorText">
        <smtt-icon icon="exclamation-circle" width="24px" class="mr-2"/>
        {{ customValidation ? $t('surveyQuestionScreen.openAnswerOption.errorMsgValidation') : $t('surveyQuestionScreen.openAnswerOption.errorMsgText') }}
      </div>
    </div>
    <div v-if="valueType === 1" class="col--12">
      <input
          v-enter-to-tab
          :key="onlyNumberInput"
          type="number"
          class="form-control form-control--text open-answer-option-input EnterToTab"
          :required="isRequired"
          :value="value"
          :readonly="viewMode"
          :disabled="viewMode"
          @blur="answered"
          @change="numberValueChange"
      />
      <div v-if="showNumberError" class="errorText">
        <smtt-icon icon="exclamation-circle" width="24px" class="mr-2"/>
        {{ $t('surveyQuestionScreen.openAnswerOption.errorMsgNumber') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  'name': 'OpenAnswerOption',
  'props': {
    // valueType = 0 is Alphanumeric
    // valueType = 1 is Numeric
    'valueType': Number,
    'answerName': String,
    'isRequired': {
      'type': Boolean,
      'required': false,
      'default': false
    },
    'viewMode': {
      'type': Boolean,
      'required': false
    },
    'customValidation': {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      'value': '',
      'onlyNumberInput': 0,
      'textInputKey': 0,
      'showNumberError': false,
      'isInvalid': false,
    }
  },
  'watch': {
    answerName(newValue) {
      this.value = newValue;
    }
  },
  'methods': {
    'textValueChange': function (e) {
      if (e.target.value) {
        this.value = e.target.value.replaceAll('-', '');
      }
    },
    'numberValueChange': function (e) {
      let newValue = e.target.value

      if (!(newValue) || isNaN(newValue)) {
        this.showNumberError = true
      } else {
        this.showNumberError = false

        if (newValue) {
          this.value = newValue.replaceAll('-', '');
        }
      }
    },
    forceRerender() {
      this.onlyNumberInput += 1
      this.textInputKey += 1
    },
    'answered': function () {
      this.forceRerender()

      if (this.value?.trim() === '') {
        this.$emit('onAnswered', null);
      } else {
        // If we have a custom validation, use that instead
        if (this.customValidation) {
          const regex = new RegExp(this.customValidation, 'g');
          this.isInvalid = !regex.test(this.value);
          this.$emit('onAnswered', this.isInvalid ? null : this.value);
        } else {
          if (this.valueType === 1) {
            if (!isNaN(this.value)) {
              this.$emit('onAnswered', this.value)
            } else {
              this.$emit('onAnswered', null);
            }
          } else {
            this.$emit('onAnswered', this.value)
          }
        }
      }
    }
  },
  created() {
    this.value = this.answerName ? this.answerName : '';
  }
}
</script>

<style scoped>

.open-answer-option-input {
  height: 36px !important;
  font-size: 1rem !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.form-control {
  box-shadow: none;
  background-color: rgb(255, 255, 255);
  height: 40px;
  font-size: 0.875rem;
  line-height: 1.5rem;
  flex: 1 1 auto;
  border: 1px solid rgb(76, 77, 87);
}

.errorText {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin-top: .25rem;
  color: rgb(142, 31, 31);
}

.input-invalid {
  border-color: rgb(142, 31, 31);
}

</style>